


import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { ViewType } from "@WhiteCap/Store/Reducer/WhiteCapReducer/ProductListViewReducer";

type HandlerType = CustomApiHandler<{ view: ViewType }>;

export const DispatchSetView: HandlerType = props => {
    props.dispatch({
        type: "Custom/ProductList/SetView",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetView];

const setView = createHandlerChainRunner(chain, "SetView");

export default setView;